module.exports = __webpack_public_path__ + "fronted/src/img/del.bd0068f2.png";